import type {
  GetDocumentCommentsRequestType,
  GetDocumentCommentsResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const getDocumentComments = async (
  params: GetDocumentCommentsRequestType,
) => {
  const url = `/api/v2/documents/${params.documentId}/comments`;
  const response =
    await apiAuthClient.get<GetDocumentCommentsResponseType>(url);

  return response.data;
};
